import type { ClientSSOContext } from './types'

const SSO_KEYS = {
  CONTEXT: 'clientSSOContext',
  STATE_NONCE: 'sso_state_nonce',
  STATE_CLIENT: 'sso_state_client',
  REDIRECT: 'redirectAfterLogin',
} as const

export const ssoStorage = {
  getContext(): ClientSSOContext | null {
    try {
      const raw = localStorage.getItem(SSO_KEYS.CONTEXT)
      return raw ? JSON.parse(raw) : null
    } catch {
      return null
    }
  },

  setContext(ctx: ClientSSOContext): void {
    localStorage.setItem(SSO_KEYS.CONTEXT, JSON.stringify(ctx))
  },

  mergeContext(partial: Partial<ClientSSOContext>): void {
    const existing = this.getContext()
    this.setContext({ ...(existing ?? {}), ...partial })
  },

  clearContext(): void {
    localStorage.removeItem(SSO_KEYS.CONTEXT)
  },

  getOAuthState(): { nonce: string; clientName: string } | null {
    const nonce = localStorage.getItem(SSO_KEYS.STATE_NONCE)
    const clientName = localStorage.getItem(SSO_KEYS.STATE_CLIENT)
    if (!nonce || !clientName) return null
    return { nonce, clientName }
  },

  setStateNonce(nonce: string, clientName: string): void {
    localStorage.setItem(SSO_KEYS.STATE_NONCE, nonce)
    localStorage.setItem(SSO_KEYS.STATE_CLIENT, clientName)
  },

  clearStateNonce(): void {
    localStorage.removeItem(SSO_KEYS.STATE_NONCE)
    localStorage.removeItem(SSO_KEYS.STATE_CLIENT)
  },

  setRedirectUrl(url: string): void {
    localStorage.setItem(SSO_KEYS.REDIRECT, url)
  },

  getAndClearRedirectUrl(): string | null {
    const url = localStorage.getItem(SSO_KEYS.REDIRECT)
    if (url) localStorage.removeItem(SSO_KEYS.REDIRECT)
    return url
  },
}
